import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaTachometerAlt, FaGraduationCap, FaUsers, FaCommentDots,
  FaLaptopCode, FaPoll, FaHeadset, FaChartPie, FaCalendarAlt, FaTrophy, FaClipboardCheck
} from 'react-icons/fa';
import mpsLogo from '../../assets/images/mps_logo.png';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api/apiClient';
import { getAssetUrl } from '../../utils/apiBase';

const ALWAYS_VISIBLE_INSTRUCTOR_MENU_IDS = [8, 9, 10];

const ALL_MENU_ITEMS = [
  {
    id: 0,
    label: 'Dashboard',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-purple-500 to-purple-700 p-2 shadow-lg group-hover:shadow-purple-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaTachometerAlt className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/dashboard'
  },
  {
    id: 1,
    label: 'My Courses',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 p-2 shadow-lg group-hover:shadow-emerald-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaGraduationCap className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/courses'
  },
  {
    id: 2,
    label: 'My Users',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 p-2 shadow-lg group-hover:shadow-blue-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaUsers className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/users'
  },
  {
    id: 4,
    label: 'Virtual-Led Training',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-orange-500 to-orange-700 p-2 shadow-lg group-hover:shadow-orange-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaLaptopCode className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/vlt'
  },
  {
    id: 9,
    label: 'Leaderboard',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-yellow-500 to-orange-600 p-2 shadow-lg group-hover:shadow-yellow-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaTrophy className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/leaderboard'
  },
  {
    id: 8,
    label: 'Event Calendar',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-violet-700 p-2 shadow-lg group-hover:shadow-violet-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaCalendarAlt className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/calendar'
  },
  {
    id: 3,
    label: 'Forum Discussions',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-500 to-cyan-700 p-2 shadow-lg group-hover:shadow-cyan-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaCommentDots className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/forums'
  },
  {
    id: 5,
    label: 'Surveys',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-violet-700 p-2 shadow-lg group-hover:shadow-violet-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaPoll className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/surveys'
  },
  {
    id: 10,
    label: 'Assessments',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-lime-500 to-lime-700 p-2 shadow-lg group-hover:shadow-lime-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaClipboardCheck className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/assessments'
  },
  {
    id: 6,
    label: 'Support Tickets',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-rose-500 to-rose-700 p-2 shadow-lg group-hover:shadow-rose-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaHeadset className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/support-tickets'
  },
  {
    id: 7,
    label: 'Reports Analytics',
    icon: (
      <div className="me-2 w-9 h-9 rounded-xl bg-gradient-to-br from-green-500 to-green-700 p-2 shadow-lg group-hover:shadow-green-500/50 group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300 flex items-center justify-center">
        <FaChartPie className="w-5 h-5 text-white" />
      </div>
    ),
    path: '/instructor/reports'
  },
];

const InstructorSidebar = ({ onTabChange }) => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user }  = useAuth();
  const roleValue = user ? parseInt(user.role) : null;
  const hasOrg = Boolean(user?.organization_id);

  const [allowedMenuIds, setAllowedMenuIds] = useState(null);
  const [orgLogoUrl, setOrgLogoUrl] = useState('');
  const [orgName, setOrgName] = useState('');
  const [orgLogoResolved, setOrgLogoResolved] = useState(false);

  useEffect(() => {
    if (roleValue === null) return;
    api.accessControl.getByRole(roleValue)
      .then((res) => {
        if (res.data?.success) {
          const { full_access, menu_ids } = res.data.data;
          setAllowedMenuIds(full_access ? null : (menu_ids ?? []));
        }
      })
      .catch(() => setAllowedMenuIds(null));
  }, [roleValue]);

  useEffect(() => {
    if (!hasOrg || !user?.organization_id) {
      setOrgLogoUrl('');
      setOrgName('');
      setOrgLogoResolved(true);
      return;
    }

    let cancelled = false;
    setOrgLogoResolved(false);

    const loadOrganizationLogo = async () => {
      try {
        const response = await api.organizations.getById(user.organization_id);
        if (cancelled) return;

        const org = response.data;
        setOrgName(org?.name || '');
        setOrgLogoUrl(org?.logo_path ? getAssetUrl(org.logo_path) : '');
      } catch (error) {
        if (!cancelled) {
          console.error('Failed to load organization logo:', error);
          setOrgLogoUrl('');
          setOrgName('');
        }
      } finally {
        if (!cancelled) {
          setOrgLogoResolved(true);
        }
      }
    };

    loadOrganizationLogo();

    return () => {
      cancelled = true;
    };
  }, [hasOrg, user?.organization_id]);

  const menuItems = allowedMenuIds === null
    ? ALL_MENU_ITEMS
    : ALL_MENU_ITEMS.filter((item) => (
      allowedMenuIds.includes(item.id) || ALWAYS_VISIBLE_INSTRUCTOR_MENU_IDS.includes(item.id)
    ));

  const handleNavigation = (item) => {
    navigate(item.path);
    if (onTabChange) onTabChange();
  };

  const useOrgLogo = hasOrg && Boolean(orgLogoUrl);
  const sidebarLogoSrc = useOrgLogo ? orgLogoUrl : mpsLogo;
  const sidebarLogoAlt = useOrgLogo
    ? (orgName ? `${orgName} logo` : 'Organization logo')
    : 'Enable LXP Logo';

  return (
    <div className="shadow-1xl">
      {/* Logo header */}
      <div className="bg-[#fefcff] border-none p-2 flex justify-center items-center hidden md:flex min-h-[4.5rem]">
        {hasOrg && !orgLogoResolved ? (
          <div className="w-32 h-14" aria-hidden="true" />
        ) : (
          <img
            src={sidebarLogoSrc}
            alt={sidebarLogoAlt}
            className="w-32 h-14 object-contain drop-shadow-md transition-transform hover:scale-105"
          />
        )}
      </div>

      {/* Menu */}
      <div className="flex-1 overflow-y-auto scrollbar-thin brand-app-sidebar-scroll brand-app-sidebar border-r border-purple-400">
        <div className="py-3 px-2">
          {menuItems.map((item) => {
            const isActive =
              location.pathname === item.path ||
              (item.path === '/instructor/dashboard' && location.pathname === '/instructor/dashboard') ||
              (item.path === '/instructor/courses'   && location.pathname.includes('/instructor/courses')) ||
              (item.path === '/instructor/users'     && location.pathname.includes('/instructor/users')) ||
              (item.path === '/instructor/forums'    && location.pathname.startsWith('/instructor/forums')) ||
              (item.path === '/instructor/vlt'       && location.pathname.includes('/instructor/vlt')) ||
              (item.path === '/instructor/calendar'  && location.pathname.includes('/instructor/calendar')) ||
              (item.path === '/instructor/surveys'   && location.pathname.includes('/instructor/surveys')) ||
              (item.path === '/instructor/assessments' && location.pathname.includes('/instructor/assessments')) ||
              (item.path === '/instructor/support-tickets' && location.pathname.includes('/instructor/support-tickets')) ||
              (item.path === '/instructor/reports'   && location.pathname.startsWith('/instructor/reports'));

            return (
              <div
                key={item.id}
                onClick={() => handleNavigation(item)}
                className={`
                  flex items-center cursor-pointer font-medium text-sm
                  min-h-12 px-2 py-2 rounded-xl group mb-1
                  transition-all duration-200 ease-in-out
                  ${isActive
                    ? 'bg-white/30 text-white shadow-md border-l-4 border-white transform scale-[1.02]'
                    : 'text-white hover:bg-white/20 hover:text-white hover:shadow-sm'
                  }
                `}
              >
                <div className="w-9 h-9 flex items-center justify-center">
                  {React.cloneElement(item.icon, {
                    className: `text-base ${isActive ? 'text-white' : 'text-purple-200 group-hover:text-white'}`
                  })}
                </div>
                <span className="flex-1 text-left leading-tight font-medium">{item.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InstructorSidebar;
